import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import { TextFieldProps } from "@material-ui/core/TextField";
import { Trad } from "src/components";

export type TTextFieldProps = TextFieldProps & {
    Value: string | number;
    Label: string;
    Id: string;
    OnChange: (name: string, val: unknown) => void;
    Disabled?: boolean;
    OnChangeDerogation?: (e: React.FormEvent<any>) => void;
};

export const _TextField: React.FC<TTextFieldProps> = ({ Disabled, Id, Label, OnChange, Value, OnChangeDerogation, ...rest }) => {
    rest.value = Value;
    return (
        <>
            {OnChangeDerogation && <FormControlLabel control={<Checkbox onChange={OnChangeDerogation} name={Id} />} label={Trad.Trad(Label)} />}
            <TextField
                id={Id}
                label={OnChangeDerogation ? "" : Trad.Trad(Label)}
                onChange={e => OnChange(e.currentTarget.id, e.currentTarget.value)}
                disabled={Disabled}
                fullWidth
                {...rest}
            />
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/form/TextField.tsx